import { render, staticRenderFns } from "./EventsIntro.vue?vue&type=template&id=5b6031e4&"
import script from "./EventsIntro.vue?vue&type=script&lang=js&"
export * from "./EventsIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports